import SearchCustomer from './SearchCustomer'

export default SearchCustomer
